import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class CheckBoxThreeStateViewModel extends ControlViewModel {

    /**
     * Gibt an, ob die CheckBox angehakt ist
     */
    public isChecked: KnockoutObservable<boolean | null>;

    /**
     * Ein optionaler Wert für die CheckBox
     */
    public value: KnockoutObservable<boolean | null>;

    /**
     * Ein Handler, der aufgerufen wird, wenn die CheckBox (oder das Label) angeklickt wird
     */
    public onClick: Function;

    /**
     * Das ViewModel für das Label
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für die CheckBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.isChecked = this.observableOrDefault(params.isChecked, null);
        this.value = this.observableOrDefault(params.value, null);
        this.onClick = this.handlerOrDefault(params.onClick);
        this.label = this.paramOrDefault(params.label, null);
    }

    /**
     * Eine Methode zum Wechseln des Zustands, falls das isEnabled() == true
     */
    public toggleIfEnabled(): void {
        if (this.isEnabled()) {
            switch (this.isChecked()) {
                case true:
                    this.isChecked(false);
                    break;
                case false:
                    this.isChecked(null);
                    break;
                default:
                    this.isChecked(true);
                    break;
            }
        }
    }

    public getValueAsString() {
        switch (this.isChecked()) {
            case true:
                return "true";
            case false:
                return "false";
            default:
                return "null";
        }
    }
}

ComponentManager.setViewModel('CheckBoxThreeStateViewModel', CheckBoxThreeStateViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');